import { ProductServicesTags } from '@aibees/elephant/components/product-services-tags';
import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { Icon } from '@aibees/shared/components';
import { HighlightableContent } from '@aibees/shared/features';
import { capitalize, classnames } from '@aibees/shared/utils';
import { Stack, useTheme } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ProductAndServicesInfoProps as Props } from './types';

export const ProductAndServicesInfo = memo(
  ({ className, isMainPage, config, isDetailPopover, data }: Props) => {
    const { api } = useCompanyReadDataContext();
    const theme = useTheme();
    const sourceData = isDetailPopover ? data : api?.data;

    return (
      <Styled.Wrapper
        className={classnames('ProductAndServicesInfo', className)}
        sx={SX.root({ isMainPage, isDetailPopover })}
      >
        <Stack sx={SX.titleRow}>
          <Icon
            name="product-and-services"
            color={theme.palette.grey[500]}
            size={isDetailPopover ? 18 : 20}
          />

          <HighlightableContent
            content={'Product & Services'}
            variant="body4"
            fontWeight="light"
            color="grey.700"
          />
        </Stack>

        <ProductServicesTags
          items={
            sourceData?.keywords?.map((k: any) => ({ label: capitalize(k) })) ??
            []
          }
          config={config}
          isDetailPopover={isDetailPopover}
        />
      </Styled.Wrapper>
    );
  }
);

ProductAndServicesInfo.displayName = 'ProductAndServicesInfo';
